import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AppThunk, RootState } from './index';
import { addSpanErrorMessage, cleanSpanErrorMessage, setNotificationButtonLoad } from './NotificationSlice';
import { AuthService } from '../services/AuthService';
import { wipeLocalStorage } from './AppSlice';
import { Api } from '../services/Api';
import { getNposProfile, getUserProfile } from './UserSlice';

type EncryptionSliceInitial = {
    localSavedPassword :  string,
    refreshToken: string,
    accessToken: string
}

const initialState : EncryptionSliceInitial = {
    localSavedPassword : '',
    refreshToken : '',
    accessToken : ''
};

const EncryptionSlice = createSlice({
    name: 'encryption',
    initialState,
    reducers: {
        setLocalPassword: (state, action: PayloadAction<string>) => {
            state.localSavedPassword = action.payload
        },
        setRefreshTokenForEncryption: (state, action) => {
            state.refreshToken = action.payload;
        },
        setAccessTokenLocally: (state, action:PayloadAction<string>) => {
            state.accessToken = action.payload;
        }
    }
});

// EXPORT DEFAULT
export const { 
    setLocalPassword,
    setRefreshTokenForEncryption,
    setAccessTokenLocally
} = EncryptionSlice.actions

export default EncryptionSlice.reducer;


// default getters
export const getRefreshToken = (state: RootState) => state.encryption.refreshToken;
export const getAccessToken = (state: RootState) => state.encryption.accessToken;
export const getLocalPassword = (state: RootState) => state.encryption.localSavedPassword;



// functions
export const decryptionProcess = (): AppThunk => async (dispatch, getState): Promise<any> => {
    
    const state = getState();
    let localpassword = state.encryption.localSavedPassword;
    const isNpos = state.app.isNpos;

    dispatch(cleanSpanErrorMessage())

    try {

        let rtDecrypted: string = state.encryption.refreshToken;
        let atDecrypted: string = state.encryption.accessToken;

        if (!rtDecrypted || !atDecrypted) {

            let refreshTokenFromLocal = '';
            let accessTokenFromLocal = '';

            try {
                refreshTokenFromLocal = await AuthService.decryptData(localpassword, 'encryptRt');
            } catch (err) {
                console.error('Erro ao obter refresh token:', err);
                dispatch(addSpanErrorMessage('Senha Incorreta'));
                throw new Error('Senha incorreta ao tentar recuperar o refresh token.');
            }

            try {
                accessTokenFromLocal = await AuthService.decryptData(localpassword, 'encryptAt');
            } catch (err) {
                console.error('Erro ao obter access token:', err);
                dispatch(addSpanErrorMessage('Senha Incorreta'));
                throw new Error('Senha incorreta ao tentar recuperar o access token.');
            }

            rtDecrypted = refreshTokenFromLocal;
            atDecrypted = accessTokenFromLocal;
            
            if(!rtDecrypted || !atDecrypted) {
                dispatch( wipeLocalStorage())
                throw new Error(`No refresh token`)
            }
        }
        
        dispatch(setAccessTokenLocally(atDecrypted));
        dispatch(setRefreshTokenForEncryption(rtDecrypted));
        Api.setRefreshToken(rtDecrypted);
        Api.setToken(atDecrypted);
        
        try {
            if (isNpos) dispatch(getNposProfile())
            else dispatch(getUserProfile())

        } catch (errAuthorization) {
            throw new Error('Error token ' + errAuthorization);
        }

    } catch (err) {
        console.error(err);
        dispatch(addSpanErrorMessage("Senha invalida"));
        dispatch(setNotificationButtonLoad(false));
    }
}

export const encryptionProcess = (): AppThunk<Promise<boolean>> => 
    async (dispatch, getState) => {
        
        const state = getState();
        const localpassword = state.encryption.localSavedPassword;
        const refreshToken = state.encryption.refreshToken;
        const accessToken = state.encryption.accessToken;
    
        const encryptRefreshToken = await AuthService.encryptData(localpassword, refreshToken, `encryptRt`);
        const encryptAccessToken = await AuthService.encryptData(localpassword, accessToken, `encryptAt`);

        if (encryptRefreshToken && encryptAccessToken) {
            dispatch(setNotificationButtonLoad(false))
            return true;
        }
    
        return false;
}